import type { ActiveSubscription } from '@ps/models';

/**
 * The monthly price + currency shown on a paid tier row, e.g.
 * `{ amount: '2.33', currency: 'USD' }`. Prices are stored without precision
 * (cents), so divide by 100. Mirrors PopshopRN's `SubscriptionCell` price
 * rendering.
 */
export function formatTierMonthlyPrice(subscription: ActiveSubscription): {
  amount: string;
  currency: string;
} {
  const price = subscription.subscription_data.creator_subscription_price;
  return {
    amount: (price.creator_sub_price_without_precision / 100).toFixed(2),
    currency: price.creator_sub_price_currency || 'USD',
  };
}
